import { createAction } from "redux-act";

export const runCalculations = createAction();
export const downloadReport = createAction();
